import { render, staticRenderFns } from "./ConfigCapacity.vue?vue&type=template&id=a4831464&scoped=true&"
import script from "./ConfigCapacity.vue?vue&type=script&lang=js&"
export * from "./ConfigCapacity.vue?vue&type=script&lang=js&"
import style0 from "./ConfigCapacity.vue?vue&type=style&index=0&id=a4831464&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4831464",
  null
  
)

export default component.exports